import { memo as Memo, useMemo } from 'react';

//* HOCs
import { withLanguageContext, withDataContext } from 'context';

//* Components
import Page from 'components/common/Page';
import ProductHeroSection from 'components/pages/singleProduct/ProductHeroSection';
import ProductDetails from 'components/pages/singleProduct/ProductDetails';
import ProductsSliderSection from 'components/common/ProductsSliderSection';
import CocktailsSection from 'components/common/CocktailsSection';
import Container from 'components/common/Container';

const SingleProduct = Memo(({ singleProducts, pageParams, selectedLang, config, translate }) => {
	//! Page data
	const pageData = useMemo(
		() => singleProducts?.[pageParams.selectedSlug]?.[selectedLang],
		[singleProducts, pageParams, selectedLang]
	);

	return (
		<Page
			meta={pageData?.product?.meta}
			className={'single-product'}
			jsonLdType={'product'}>
			{pageData && (
				<>
					<ProductHeroSection
						hasBackground={true}
						btnUrl={config.products.path}
						name={pageData.product.name}
						text={pageData.product.text}
						availableIn={pageData.product.available_in}
						alcoholVolume={pageData.product.alcohol_volume}
						image={pageData.product.hero_image}
						collection={pageData.product.collection}
					/>

					<ProductDetails {...pageData.product.detail} />

					{pageData.cocktails && pageData.cocktails.length > 0 && (
						<Container full>
							<CocktailsSection
								title={`cocktailsWithOurProduct`}
								cocktails={pageData.cocktails}
								button={{ url: config.cocktails.slug, text: 'seeAllCocktails' }}
							/>
						</Container>
					)}

					{pageData.relatedProducts && pageData.relatedProducts.length > 0 && (
						<ProductsSliderSection
							title={`${pageData.product.collection} ${translate('collection')}`}
							products={pageData.relatedProducts}
						/>
					)}
				</>
			)}
		</Page>
	);
});
export default withLanguageContext(withDataContext(SingleProduct, ['singleProducts']), ['translate']);
